import { Service } from "@roc/feature-app-core";
import { LeaseRow } from "../util/types";

const url = {
  GET_LEASE_UNIT_INFO: '/api/v1/doc-review/leases/unit/getLeaseUnitInfo',
  SAVE_LEASE_UNIT: '/api/v1/doc-review/leases/unit/leaseRecord/save',
  UPLOAD_LEASE_UNIT: '/api/v1/doc-review/leases/unit/leaseRecord/upload',
  DOWNLOAD_LEASE_UNIT: '/api/v1/doc-review/leases/unit/leaseRecord/download',
};

export class LeaseUnitService extends Service {

  getLeaseUnitInfo(loanId: number, propertyId: number, taskId: number) {
    return this.get(url.GET_LEASE_UNIT_INFO, { loanId, propertyId, taskId });
  }

  saveLeaseUnit(lease: Partial<LeaseRow>) {
    return this.post(url.SAVE_LEASE_UNIT, lease);
  }

  uploadLeaseUnit(file: File, loanId: number, propertyId: number, taskId: number) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('loanId', String(loanId));
    formData.append('propertyId', String(propertyId));
    formData.append('taskId', String(taskId));
    return this.post(url.UPLOAD_LEASE_UNIT, formData);
  }

  downloadLeaseUnit(leaseId: number) {
    return this.get(url.DOWNLOAD_LEASE_UNIT, { leaseId }, { responseType: 'arraybuffer' });
  }

}
